import { render, staticRenderFns } from "./createYuce.vue?vue&type=template&id=205bdbbe"
import script from "./createYuce.vue?vue&type=script&lang=js"
export * from "./createYuce.vue?vue&type=script&lang=js"
import style0 from "./createYuce.vue?vue&type=style&index=0&id=205bdbbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports